import { IkasProductBuyXThenGetY } from "../product-buyx-then-gety";
import { IkasProductCampaignDateRangeField } from "../product-campaign-date-range-field";
import { IkasProductFixedDiscount } from "../product-fixed-discount";

export type IkasProductCampaignData = {
  applicableCustomerGroupIds: string[] | null;
  applicableCustomerIds: string[] | null;
  applicablePrice: IkasCampaignApplicablePrice;
  buyXThenGetY: IkasProductBuyXThenGetY;
  canCombineWithOtherCampaigns: boolean;
  createdFor: IkasCampaignCreatedFor | null;
  currencyCodes: [string] | null;
  dateRange: IkasProductCampaignDateRangeField | null;
  deleted: boolean;
  fixedDiscount: IkasProductFixedDiscount | null;
  hasCoupon: boolean;
  id: string;
  includeDiscountedProducts: boolean | null;
  salesChannelIds: string[] | null;
  title: string;
  type: IkasCampaignType;
  usageCount: number;
  usageLimit: number | null;
  usageLimitPerCustomer: number | null;
};

export enum IkasCampaignApplicablePrice {
  DISCOUNT_PRICE = "DISCOUNT_PRICE",
  SELL_PRICE = "SELL_PRICE",
}

export enum IkasCampaignCreatedFor {
  ABANDONED_CHECKOUT = "ABANDONED_CHECKOUT",
  CART = "CART",
  CUSTOMER_REVIEW = "CUSTOMER_REVIEW",
}

export enum IkasCampaignType {
  BUY_X_THEN_GET_Y = "BUY_X_THEN_GET_Y",
  FIXED_AMOUNT = "FIXED_AMOUNT",
  FREE_SHIPPING = "FREE_SHIPPING",
  RATIO = "FREE_SHIPPING",
}
